export default {"src":"/_next/static/media/etehadie.087713cd.svg","height":233,"width":168,"blurWidth":0,"blurHeight":0};